'use client';

import * as React from 'react';
import LayoutOverlay from '@/components/ui/LayoutOverlay';
import Overlay from '@/components/ui/Overlay';
import { useOverlay } from '@/components/hooks/useOverlay';
import Button from '@/components/ui/Button';
import Block from '@/components/ui/Block';
import Buttons from '@/components/ui/Buttons';
import { useTranslations } from '@/lib/hooks/useTranslations';
import { OverlayPurchaseTicketsFailureMeta } from '@/components/overlays/overlays';

const OverlayPurchaseFailureClient: React.FunctionComponent = () => {
  const { closeOverlay, isOverlayOpen, overlayMeta } = useOverlay<OverlayPurchaseTicketsFailureMeta>(`purchase-failure`);
  const t = useTranslations(`OverlayPurchaseFailure`, overlayMeta.ns);

  return (
    <Overlay
      isOpen={isOverlayOpen}
      onClose={closeOverlay}
      layout="default"
      hideClose={true}
    >
      <LayoutOverlay
        size="small"
        header={{
          icon: 'status-error',
          iconIntent: 'danger',
          title: t('purchaseFailedTitle'),
          onClose: closeOverlay,
          align: 'center',
        }}
      >
        <Block>
          <p className="font-size-large normal align-center">{t(overlayMeta.failureMessage || 'paymentFailed')}</p>
          <Buttons layout="centered">
            <Button
              title={t('btnTryAgain')}
              onClick={closeOverlay}
            />
          </Buttons>
        </Block>
      </LayoutOverlay>
    </Overlay>
  );
};

OverlayPurchaseFailureClient.displayName = 'OverlayPurchaseFailureClient';

export default OverlayPurchaseFailureClient;
